export enum AppointmentStatus {
  IN_REVIEW = 'InReview',
  SCHEDULED = 'Scheduled',
  CANCELLED = 'Cancelled',
  COMPLETED = 'Completed',
  RESCHEDULED = 'Rescheduled',
}
